// AUTO-GENERATED from Wurgaft et al. "Scaling up the think-aloud method" (CogSci 2025).
// Source repo: https://github.com/benpry/think-aloud-llms (MIT licence). EXACT replication
// stimuli: 20 counterbalanced conditions of 10 puzzles (one per difficulty
// decile; the experiment shuffles presentation order), per-puzzle 4nums difficulty (rank
// 1=easiest..1362=hardest + human solve rate), and the 2 practice puzzles. TEST mode uses
// these; do not edit by hand.

export const WURGAFT_PRACTICE: ReadonlyArray<number[]> = [[6, 1, 1, 2], [8, 2, 1, 1]]

export const WURGAFT_CONDITIONS: ReadonlyArray<ReadonlyArray<number[]>> = [
  [[1,1,5,5], [1,3,6,7], [1,5,5,6], [7,7,11,12], [6,8,12,12], [3,4,8,12], [7,8,8,9], [2,3,5,10], [5,5,7,10], [1,2,7,7]],
  [[1,6,6,11], [7,9,13,13], [1,6,8,13], [2,3,10,13], [4,5,6,10], [2,6,8,13], [3,7,7,9], [2,5,8,10], [1,5,5,10], [3,5,10,10]],
  [[5,5,12,12], [1,2,3,8], [6,7,12,12], [4,10,12,12], [3,9,10,12], [2,4,6,13], [1,3,7,12], [1,5,6,11], [6,8,11,12], [5,10,10,11]],
  [[1,5,7,11], [1,8,9,12], [3,3,9,9], [3,4,8,10], [2,4,6,9], [6,6,11,12], [4,4,5,10], [7,8,8,11], [3,3,9,11], [4,8,8,11]],
  [[6,6,6,6], [11,13,13,13], [3,3,11,12], [5,10,13,13], [1,4,5,11], [7,9,9,13], [1,1,7,10], [6,9,9,11], [7,10,10,12], [2,2,10,11]],
  [[2,2,3,12], [3,8,12,12], [2,8,9,12], [1,11,12,13], [6,6,8,12], [4,4,8,11], [6,7,9,12], [1,4,5,8], [3,5,9,9], [1,6,11,13]],
  [[1,1,4,6], [1,4,7,13], [1,4,4,4], [4,7,7,8], [2,3,9,10], [4,7,12,12], [3,3,6,12], [5,5,8,13], [2,2,7,7], [2,4,7,12]],
  [[1,1,11,11], [1,2,4,4], [4,4,5,6], [1,5,10,12], [6,6,8,9], [1,2,7,11], [2,2,3,11], [3,6,8,13], [1,2,8,10], [2,2,7,10]],
  [[1,4,7,12], [1,7,8,10], [5,7,13,13], [3,6,12,12], [1,3,6,13], [2,7,9,13], [2,2,5,12], [3,9,10,13], [4,7,8,12], [2,7,7,10]],
  [[1,1,2,6], [10,11,11,12], [9,10,10,13], [5,6,8,8], [2,2,9,11], [5,8,8,9], [2,4,5,9], [5,5,8,10], [3,5,7,11], [1,3,9,10]],
  [[1,2,2,6], [1,8,8,12], [1,8,10,12], [1,3,6,9], [4,4,4,7], [3,4,8,11], [3,5,7,10], [1,7,10,13], [2,8,10,12], [2,3,13,13]],
  [[2,2,11,13], [1,4,6,13], [1,2,5,7], [1,11,11,12], [1,4,12,12], [1,3,3,10], [3,3,6,10], [7,12,12,13], [2,3,7,10], [3,5,8,13]],
  [[3,3,12,12], [9,9,11,13], [1,3,3,7], [2,3,3,7], [4,5,5,9], [2,2,5,11], [6,6,7,10], [4,4,9,11], [4,7,8,11], [8,9,11,11]],
  [[1,1,2,13], [1,1,5,8], [2,12,12,13], [3,5,6,8], [4,7,8,13], [6,9,9,12], [3,3,6,13], [8,9,9,12], [2,6,6,7], [5,9,10,11]],
  [[1,6,8,9], [8,9,12,13], [4,8,8,12], [1,5,9,10], [6,7,8,10], [1,6,12,13], [5,5,10,10], [3,5,6,11], [3,5,12,12], [5,6,8,13]],
  [[2,2,12,12], [5,5,7,7], [7,9,11,11], [2,2,3,3], [4,4,8,10], [5,5,6,11], [3,9,13,13], [2,8,10,13], [2,2,6,7], [2,3,7,9]],
  [[1,2,3,4], [1,1,5,6], [1,4,8,11], [5,6,7,8], [3,3,6,11], [1,5,10,13], [3,5,7,9], [7,8,8,12], [2,6,8,9], [9,11,12,13]],
  [[4,6,13,13], [1,2,2,13], [1,11,12,12], [3,4,7,9], [2,3,6,6], [5,6,7,7], [3,3,3,9], [3,3,3,4], [8,8,8,11], [3,3,7,13]],
  [[12,12,13,13], [6,8,10,12], [2,6,10,10], [1,2,11,13], [6,8,8,10], [4,5,5,8], [5,6,7,13], [6,7,9,9], [6,10,10,13], [4,4,7,7]],
  [[4,6,11,11], [8,9,12,12], [1,2,3,3], [1,2,7,9], [1,11,13,13], [5,8,9,11], [2,3,5,13], [2,3,6,7], [7,10,11,13], [1,4,5,6]],
]

export type WurgaftMeta = { rank: number; solveRate: number; amt: number }
// keyed by the four numbers sorted ascending and comma-joined, e.g. "1,1,11,11"
export const WURGAFT_PUZZLE_META: Record<string, WurgaftMeta> = {
  "1,1,11,11": { rank: 2, solveRate: 99.6, amt: 4.41 },
  "6,6,6,6": { rank: 5, solveRate: 99.4, amt: 4.59 },
  "1,2,2,6": { rank: 7, solveRate: 99.2, amt: 4.8 },
  "1,1,4,6": { rank: 1, solveRate: 99.2, amt: 4.4 },
  "1,1,5,5": { rank: 51, solveRate: 99.1, amt: 5.35 },
  "1,2,3,4": { rank: 22, solveRate: 99, amt: 5.1 },
  "4,6,11,11": { rank: 14, solveRate: 98.9, amt: 5 },
  "5,5,12,12": { rank: 62, solveRate: 98.7, amt: 5.42 },
  "2,2,12,12": { rank: 104, solveRate: 98.7, amt: 5.68 },
  "3,3,12,12": { rank: 52, solveRate: 98.7, amt: 5.36 },
  "4,6,13,13": { rank: 36, solveRate: 98.7, amt: 5.24 },
  "1,1,2,13": { rank: 31, solveRate: 98.7, amt: 5.19 },
  "12,12,13,13": { rank: 59, solveRate: 98.6, amt: 5.4 },
  "1,5,7,11": { rank: 179, solveRate: 98.5, amt: 6.03 },
  "1,1,2,6": { rank: 20, solveRate: 98.4, amt: 5.09 },
  "1,4,7,12": { rank: 87, solveRate: 98.3, amt: 5.59 },
  "1,6,6,11": { rank: 111, solveRate: 98.2, amt: 5.71 },
  "1,6,8,9": { rank: 186, solveRate: 98.2, amt: 6.05 },
  "2,2,3,12": { rank: 124, solveRate: 98, amt: 5.76 },
  "2,2,11,13": { rank: 182, solveRate: 98, amt: 6.04 },
  "11,13,13,13": { rank: 136, solveRate: 97.8, amt: 5.85 },
  "5,5,7,7": { rank: 100, solveRate: 97.8, amt: 5.65 },
  "1,7,8,10": { rank: 173, solveRate: 97.5, amt: 5.99 },
  "1,4,6,13": { rank: 285, solveRate: 97.5, amt: 6.51 },
  "6,8,10,12": { rank: 341, solveRate: 97.2, amt: 6.74 },
  "1,2,4,4": { rank: 172, solveRate: 97.1, amt: 5.99 },
  "1,2,3,8": { rank: 219, solveRate: 97, amt: 6.2 },
  "9,9,11,13": { rank: 132, solveRate: 96.8, amt: 5.81 },
  "1,1,5,6": { rank: 32, solveRate: 96.8, amt: 5.19 },
  "10,11,11,12": { rank: 494, solveRate: 96.7, amt: 7.31 },
  "3,8,12,12": { rank: 181, solveRate: 96.5, amt: 6.03 },
  "1,8,9,12": { rank: 80, solveRate: 96.5, amt: 5.56 },
  "1,4,7,13": { rank: 293, solveRate: 96.5, amt: 6.54 },
  "1,2,2,13": { rank: 435, solveRate: 96.4, amt: 7.09 },
  "1,1,5,8": { rank: 13, solveRate: 96.4, amt: 5 },
  "7,9,13,13": { rank: 362, solveRate: 96.3, amt: 6.83 },
  "1,8,8,12": { rank: 90, solveRate: 96.3, amt: 5.61 },
  "8,9,12,12": { rank: 122, solveRate: 96.2, amt: 5.75 },
  "1,3,6,7": { rank: 383, solveRate: 96, amt: 6.91 },
  "8,9,12,13": { rank: 384, solveRate: 96, amt: 6.91 },
  "1,3,3,7": { rank: 262, solveRate: 95.9, amt: 6.41 },
  "3,3,9,9": { rank: 496, solveRate: 95.9, amt: 7.32 },
  "7,9,11,11": { rank: 241, solveRate: 95.8, amt: 6.29 },
  "1,4,4,4": { rank: 515, solveRate: 95.7, amt: 7.41 },
  "2,6,10,10": { rank: 442, solveRate: 95.7, amt: 7.11 },
  "4,4,5,6": { rank: 240, solveRate: 95.7, amt: 6.29 },
  "1,8,10,12": { rank: 134, solveRate: 95.6, amt: 5.83 },
  "6,7,12,12": { rank: 81, solveRate: 95.6, amt: 5.56 },
  "2,12,12,13": { rank: 242, solveRate: 95.5, amt: 6.3 },
  "1,2,3,3": { rank: 734, solveRate: 95.5, amt: 8.59 },
  "1,4,8,11": { rank: 596, solveRate: 95.4, amt: 7.83 },
  "9,10,10,13": { rank: 516, solveRate: 95.2, amt: 7.41 },
  "2,8,9,12": { rank: 323, solveRate: 95, amt: 6.66 },
  "1,2,5,7": { rank: 336, solveRate: 95, amt: 6.73 },
  "1,5,5,6": { rank: 531, solveRate: 94.9, amt: 7.48 },
  "3,3,11,12": { rank: 115, solveRate: 94.7, amt: 5.72 },
  "4,8,8,12": { rank: 766, solveRate: 94.4, amt: 8.83 },
  "1,6,8,13": { rank: 478, solveRate: 94.3, amt: 7.27 },
  "5,7,13,13": { rank: 529, solveRate: 94.2, amt: 7.47 },
  "1,11,12,12": { rank: 378, solveRate: 94.2, amt: 6.9 },
  "4,7,7,8": { rank: 198, solveRate: 93.8, amt: 6.09 },
  "1,11,12,13": { rank: 501, solveRate: 93.8, amt: 7.35 },
  "7,7,11,12": { rank: 71, solveRate: 93.7, amt: 5.49 },
  "1,5,9,10": { rank: 644, solveRate: 93.5, amt: 8.07 },
  "1,2,11,13": { rank: 348, solveRate: 93.5, amt: 6.78 },
  "5,6,7,8": { rank: 576, solveRate: 93.5, amt: 7.71 },
  "3,5,6,8": { rank: 502, solveRate: 93.5, amt: 7.35 },
  "1,11,11,12": { rank: 158, solveRate: 93.4, amt: 5.93 },
  "3,4,8,10": { rank: 479, solveRate: 93.4, amt: 7.27 },
  "2,3,10,13": { rank: 721, solveRate: 93.4, amt: 8.51 },
  "1,2,7,9": { rank: 825, solveRate: 93.3, amt: 9.26 },
  "2,2,3,3": { rank: 627, solveRate: 93.3, amt: 7.96 },
  "1,3,6,9": { rank: 632, solveRate: 93.1, amt: 7.99 },
  "3,4,7,9": { rank: 616, solveRate: 93.1, amt: 7.9 },
  "3,6,12,12": { rank: 570, solveRate: 93, amt: 7.69 },
  "5,10,13,13": { rank: 533, solveRate: 92.5, amt: 7.48 },
  "5,6,8,8": { rank: 500, solveRate: 92.2, amt: 7.34 },
  "2,3,3,7": { rank: 699, solveRate: 92.1, amt: 8.4 },
  "1,5,10,12": { rank: 296, solveRate: 92, amt: 6.55 },
  "4,10,12,12": { rank: 635, solveRate: 92, amt: 8 },
  "2,3,6,6": { rank: 954, solveRate: 91.9, amt: 10.65 },
  "1,3,6,13": { rank: 673, solveRate: 91.8, amt: 8.2 },
  "2,4,6,9": { rank: 731, solveRate: 91.8, amt: 8.58 },
  "6,7,8,10": { rank: 612, solveRate: 91.6, amt: 7.88 },
  "6,8,12,12": { rank: 759, solveRate: 91.5, amt: 8.77 },
  "2,2,9,11": { rank: 598, solveRate: 91.5, amt: 7.84 },
  "4,4,8,10": { rank: 761, solveRate: 91.4, amt: 8.8 },
  "1,11,13,13": { rank: 716, solveRate: 91.3, amt: 8.49 },
  "4,5,5,9": { rank: 796, solveRate: 91.3, amt: 8.99 },
  "1,4,12,12": { rank: 238, solveRate: 91.2, amt: 6.29 },
  "4,4,4,7": { rank: 514, solveRate: 91.1, amt: 7.4 },
  "6,8,8,10": { rank: 668, solveRate: 91, amt: 8.16 },
  "6,6,8,12": { rank: 855, solveRate: 90.8, amt: 9.53 },
  "4,7,8,13": { rank: 854, solveRate: 90.7, amt: 9.53 },
  "1,4,5,11": { rank: 656, solveRate: 90.6, amt: 8.12 },
  "4,5,6,10": { rank: 901, solveRate: 90.3, amt: 10.02 },
  "6,6,8,9": { rank: 696, solveRate: 90.3, amt: 8.38 },
  "3,9,10,12": { rank: 781, solveRate: 90.2, amt: 8.92 },
  "3,3,6,11": { rank: 816, solveRate: 90.2, amt: 9.21 },
  "2,3,9,10": { rank: 948, solveRate: 90, amt: 10.55 },
  "5,8,9,11": { rank: 677, solveRate: 89.9, amt: 8.24 },
  "1,3,3,10": { rank: 783, solveRate: 89.6, amt: 8.94 },
  "1,6,12,13": { rank: 694, solveRate: 89.4, amt: 8.38 },
  "6,6,11,12": { rank: 274, solveRate: 88.9, amt: 6.46 },
  "1,5,10,13": { rank: 812, solveRate: 88.6, amt: 9.13 },
  "4,7,12,12": { rank: 203, solveRate: 88.5, amt: 6.12 },
  "1,2,7,11": { rank: 943, solveRate: 88.1, amt: 10.5 },
  "4,5,5,8": { rank: 482, solveRate: 88, amt: 7.28 },
  "7,9,9,13": { rank: 926, solveRate: 88, amt: 10.26 },
  "5,6,7,7": { rank: 330, solveRate: 87.8, amt: 6.69 },
  "3,4,8,12": { rank: 991, solveRate: 87.7, amt: 11.17 },
  "2,2,5,11": { rank: 807, solveRate: 87.4, amt: 9.1 },
  "2,6,8,13": { rank: 961, solveRate: 87.2, amt: 10.72 },
  "2,4,6,13": { rank: 865, solveRate: 87.2, amt: 9.65 },
  "2,7,9,13": { rank: 840, solveRate: 87.2, amt: 9.41 },
  "3,4,8,11": { rank: 883, solveRate: 87.2, amt: 9.88 },
  "5,5,6,11": { rank: 896, solveRate: 87.1, amt: 10 },
  "5,8,8,9": { rank: 597, solveRate: 87, amt: 7.83 },
  "6,9,9,12": { rank: 1057, solveRate: 87, amt: 12.26 },
  "4,4,8,11": { rank: 689, solveRate: 87, amt: 8.33 },
  "3,3,6,12": { rank: 1006, solveRate: 86.9, amt: 11.36 },
  "6,7,9,12": { rank: 866, solveRate: 86.8, amt: 9.65 },
  "5,5,10,10": { rank: 394, solveRate: 86.7, amt: 6.94 },
  "3,7,7,9": { rank: 468, solveRate: 86.6, amt: 7.22 },
  "7,8,8,9": { rank: 449, solveRate: 86.6, amt: 7.13 },
  "3,3,6,10": { rank: 882, solveRate: 86.4, amt: 9.87 },
  "3,3,6,13": { rank: 898, solveRate: 86.4, amt: 10.01 },
  "5,6,7,13": { rank: 922, solveRate: 86.4, amt: 10.2 },
  "3,9,13,13": { rank: 513, solveRate: 86.3, amt: 7.4 },
  "2,4,5,9": { rank: 848, solveRate: 86.3, amt: 9.49 },
  "4,4,5,10": { rank: 787, solveRate: 86.3, amt: 8.96 },
  "3,5,7,9": { rank: 1025, solveRate: 86.2, amt: 11.66 },
  "2,2,3,11": { rank: 806, solveRate: 86.1, amt: 9.1 },
  "2,3,5,13": { rank: 1048, solveRate: 85.5, amt: 12.07 },
  "1,3,7,12": { rank: 1024, solveRate: 85.4, amt: 11.64 },
  "1,1,7,10": { rank: 647, solveRate: 85.1, amt: 8.08 },
  "2,2,5,12": { rank: 960, solveRate: 84.8, amt: 10.72 },
  "3,5,7,10": { rank: 978, solveRate: 84.5, amt: 10.99 },
  "3,3,3,9": { rank: 824, solveRate: 84.5, amt: 9.25 },
  "6,6,7,10": { rank: 584, solveRate: 84.2, amt: 7.75 },
  "1,7,10,13": { rank: 965, solveRate: 83.7, amt: 10.75 },
  "7,8,8,12": { rank: 956, solveRate: 83.6, amt: 10.66 },
  "3,9,10,13": { rank: 969, solveRate: 83, amt: 10.83 },
  "2,5,8,10": { rank: 1040, solveRate: 82.9, amt: 11.88 },
  "1,4,5,8": { rank: 1099, solveRate: 82.7, amt: 13.16 },
  "7,12,12,13": { rank: 803, solveRate: 82.6, amt: 9.05 },
  "4,4,9,11": { rank: 729, solveRate: 82.5, amt: 8.57 },
  "3,5,6,11": { rank: 1072, solveRate: 82.5, amt: 12.59 },
  "3,3,3,4": { rank: 1061, solveRate: 82.4, amt: 12.34 },
  "8,9,9,12": { rank: 1014, solveRate: 82.4, amt: 11.45 },
  "6,9,9,11": { rank: 934, solveRate: 82.4, amt: 10.33 },
  "3,6,8,13": { rank: 1153, solveRate: 81.3, amt: 14.97 },
  "5,5,8,10": { rank: 923, solveRate: 81.3, amt: 10.21 },
  "1,5,6,11": { rank: 1096, solveRate: 81, amt: 13.06 },
  "2,8,10,13": { rank: 1104, solveRate: 80.9, amt: 13.34 },
  "5,5,8,13": { rank: 989, solveRate: 80.8, amt: 11.11 },
  "2,3,6,7": { rank: 1175, solveRate: 80.8, amt: 16.08 },
  "7,8,8,11": { rank: 714, solveRate: 80.6, amt: 8.48 },
  "6,7,9,9": { rank: 1010, solveRate: 80.4, amt: 11.41 },
  "2,3,5,10": { rank: 1103, solveRate: 80.2, amt: 13.29 },
  "2,8,10,12": { rank: 1202, solveRate: 79.8, amt: 17.74 },
  "3,5,9,9": { rank: 1118, solveRate: 79.4, amt: 13.9 },
  "4,7,8,12": { rank: 1150, solveRate: 79.4, amt: 14.95 },
  "3,3,9,11": { rank: 1123, solveRate: 79.1, amt: 14.2 },
  "2,6,6,7": { rank: 1052, solveRate: 78.4, amt: 12.21 },
  "7,10,10,12": { rank: 1053, solveRate: 78, amt: 12.21 },
  "6,8,11,12": { rank: 1108, solveRate: 77.9, amt: 13.39 },
  "2,3,7,10": { rank: 1190, solveRate: 76.9, amt: 16.91 },
  "5,5,7,10": { rank: 1100, solveRate: 73.8, amt: 13.19 },
  "7,10,11,13": { rank: 1111, solveRate: 73.3, amt: 13.49 },
  "2,2,6,7": { rank: 1176, solveRate: 72.5, amt: 16.26 },
  "2,6,8,9": { rank: 1210, solveRate: 72.4, amt: 18.52 },
  "1,5,5,10": { rank: 1168, solveRate: 71.2, amt: 15.65 },
  "2,2,7,7": { rank: 1152, solveRate: 69.8, amt: 14.97 },
  "6,10,10,13": { rank: 1138, solveRate: 69.1, amt: 14.57 },
  "4,7,8,11": { rank: 1171, solveRate: 69, amt: 15.79 },
  "1,2,8,10": { rank: 1233, solveRate: 67.7, amt: 20.88 },
  "3,5,12,12": { rank: 1127, solveRate: 67.2, amt: 14.26 },
  "3,5,7,11": { rank: 1240, solveRate: 64, amt: 21.39 },
  "8,8,8,11": { rank: 1192, solveRate: 63.5, amt: 17.01 },
  "2,3,13,13": { rank: 1268, solveRate: 58.4, amt: 26.93 },
  "8,9,11,11": { rank: 1263, solveRate: 58, amt: 25.64 },
  "2,3,7,9": { rank: 1276, solveRate: 57.6, amt: 30.64 },
  "1,2,7,7": { rank: 1282, solveRate: 55, amt: 32.73 },
  "3,5,10,10": { rank: 1260, solveRate: 54.3, amt: 25.12 },
  "2,2,7,10": { rank: 1278, solveRate: 53.4, amt: 30.9 },
  "5,9,10,11": { rank: 1301, solveRate: 42.7, amt: 47.17 },
  "3,5,8,13": { rank: 1306, solveRate: 41.9, amt: 50.53 },
  "5,10,10,11": { rank: 1297, solveRate: 41.3, amt: 42.21 },
  "1,3,9,10": { rank: 1310, solveRate: 40.8, amt: 55.16 },
  "4,4,7,7": { rank: 1312, solveRate: 38.8, amt: 56.41 },
  "1,6,11,13": { rank: 1309, solveRate: 38.1, amt: 54.62 },
  "5,6,8,13": { rank: 1330, solveRate: 36.4, amt: 68.54 },
  "2,2,10,11": { rank: 1347, solveRate: 30.2, amt: 96.37 },
  "4,8,8,11": { rank: 1341, solveRate: 30, amt: 88.95 },
  "1,4,5,6": { rank: 1360, solveRate: 28.7, amt: 195.91 },
  "2,4,7,12": { rank: 1353, solveRate: 28.1, amt: 108.41 },
  "9,11,12,13": { rank: 1348, solveRate: 27.9, amt: 99.38 },
  "3,3,7,13": { rank: 1339, solveRate: 27.6, amt: 88.82 },
  "2,7,7,10": { rank: 1343, solveRate: 27, amt: 90.8 },
}
